import React from "react";
import "./state-indicator.scss";
import Spinner from "./spinner";
import ErrorIndicator from "./error-indicator";

import Localized from "../localized";

let StateIndicator = Indicator => props => {
    const { withCaption = false, captionText, small, verySmall, fillParent = true, transparent } = props;
    const clazzName =
        "state-indicator" +
        (small ? " size_s" : verySmall ? " size_xs" : "") + // Размер анимированной иконки ожидания
        (withCaption || captionText ? " state-indicator_with_caption" : "") + // Нужен ли заголовок (либо по умолчанию либо заданный)
        (fillParent ? " state-indicator_fillParent" : "") + // Заполнять ли родительский контейнер по его размерам или иметь свой фиксированный размер (важно когда родитель имеет высоту 0)
        (transparent ? " state-indicator_transparent" : ""); // Прозрачный фон
    return (
        <div className={clazzName}>
            <div className="state-indicator__container">
                <Localized>
                    <Indicator {...props} />
                </Localized>
            </div>
        </div>
    );
};

const SpinnerComp = StateIndicator(Spinner);
const ErrorIndicatorComp = StateIndicator(ErrorIndicator);
export { SpinnerComp as Spinner, ErrorIndicatorComp as ErrorIndicator };
